import colors from '../colors';

export const reports = [
  { key: 'pdf1', name: 'module.lc.export.pdf1', color: colors.danger },
  { key: 'xls1', name: 'module.lc.export.xls1', color: colors.success },
  { key: 'xls2', name: 'module.lc.export.xls2', color: colors.success },
  { key: 'xls3', name: 'module.lc.export.xls3', color: colors.success },
  { key: 'xls4', name: 'module.lc.export.xls4', color: colors.success },
  { key: 'xls5', name: 'module.lc.export.xls5', color: colors.success },
  { key: 'xls6', name: 'module.lc.export.xls6', color: colors.success },
  { key: 'xls7', name: 'module.lc.export.xls7', color: colors.success },
  { key: 'doc1', name: 'module.lc.export.doc1', color: colors.primary },
  { key: 'doc2', name: 'module.lc.export.doc2', color: colors.primary },
  { key: 'doc3', name: 'module.lc.export.doc3', color: colors.primary },
];

export function getGCLReportIconTitle(reportType) {
  let out;

  if (reportType.startsWith('pdf')) out = 'PDF';
  else if (reportType.startsWith('xls')) out = 'EXCEL';
  else if (reportType.startsWith('doc')) out = 'WORD';

  out += ` - ${reportType}`;

  return out;
}

export function getGCLReportIcon(reportType) {
    let type = 'file-';
    if (reportType.startsWith('pdf')) {
      type += 'pdf';
    } else if (reportType.startsWith('xls')) {
      type += 'excel';
    } else if (reportType.startsWith('doc')) {
      type += 'word';
    }

    return type;
  };

export function getIconType(reportType) {
  if (reportType.startsWith('pdf')) return 'pdf';
  if (reportType.startsWith('xls')) return 'xls';
  if (reportType.startsWith('doc')) return 'doc';
}

export function getGCLReportIconColor(reportType) {
  if (reportType.startsWith('pdf')) return colors.danger;
  if (reportType.startsWith('xls')) return colors.success;
  if (reportType.startsWith('doc')) return colors.primary;
}

export function getGCLReportNumber(reportType) {
  return reportType.replace(/\D/g, '');
}
